/* Collection cards: show the STYLE's review count, not the colourway's.

   The theme renders each card's rating from that product's own
   reviews.rating_count metafield. Colourways are separate products on
   this store, so one style is split across several cards:

     Seamless Sculpt Bodysuit | Midnight   (13)
     Seamless Sculpt Bodysuit | Cocoa      (21)
     Seamless Sculpt Bodysuit | Almond     (13)

   ...when the style has earned 47. A shopper landing on the weakest
   colour sees the weakest number.

   This groups cards by the part of the title BEFORE the '|' - the same
   rule shaped-reviews.js uses on the PDP - sums the counts and
   recomputes a weighted average.

   ---------------------------------------------------------------
   THREE THINGS THAT WILL BITE YOU IF YOU EDIT THIS

   1. THE TITLE IS NOT THE LINK TEXT. The whole card is wrapped in
      <a class="product-card-link">, so that anchor's textContent is the
      badge, the price and the rating all run together ("13% OFF..."). 
      Grouping on it collapses every card on the page into one bucket.
      The title lives in p.product-card-item__head.

   2. NEVER SUM FROM WHAT IS ON SCREEN. This runs more than once (load,
      section:load, two delays). Reading the rendered count means the
      second pass adds up numbers the first pass wrote, and the total
      runs away - it reached 3384 in testing. Originals are cached in
      data-spb-orig / data-spb-orig-avg on first sight and every pass
      sums only those, so re-running is idempotent.

   3. DEDUPE BY URL. The same product can appear twice on a page
      (grid plus a recommendations carousel). Counting the elements
      instead of the distinct products doubles the total.

   ---------------------------------------------------------------
   DISPLAY ONLY. The metafields are untouched, so structured data,
   Google Shopping and the Judge.me widgets still report per product -
   the number a shopper sees and the number Google gets will differ. If
   that matters, the metafields or the JSON-LD have to change too.

   Every colourway of a style shows the same number, so a collection
   listing all three bodysuits shows (47) three times. Accurate, but
   repetitive. To switch it off, remove the shaped-collection.js include
   from layout/theme.liquid.

   ---------------------------------------------------------------
   HOW THE THEME STORES THE AVERAGE

     <span class="rating-star" style="--rating:5; --rating-decimal:0.92">

   Not what it looks like: --rating is the CEILING and --rating-decimal
   the fractional part, so the average is (--rating - 1 + decimal).
   4.92 -> rating 5, decimal 0.92. We read and write it the same way. */
(function(){

  function readCount(el){
    var fromAria = (el.getAttribute('aria-label') || '').replace(/[^0-9]+/g, '');
    if (fromAria) return parseInt(fromAria, 10);
    var fromText = (el.textContent || '').replace(/[^0-9]+/g, '');
    return fromText ? parseInt(fromText, 10) : NaN;
  }

  /* p.product-card-item__head, NOT the wrapping anchor - see note 1. */
  function cardTitle(card){
    var head = card.querySelector('.product-card-item__head');
    if (head){
      var t = (head.textContent || '').replace(/\s+/g, ' ').trim();
      if (t) return t;
    }
    var links = card.querySelectorAll('a[href*="/products/"]');
    for (var i = links.length - 1; i >= 0; i--){
      var lt = (links[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (lt && lt.length < 120) return lt;
    }
    return '';
  }

  function productKey(href){
    return (href || '').split('?')[0].replace(/\/+$/, '');
  }

  function run(){
    var cards = document.querySelectorAll('product-card, .product-card-item');
    if (!cards.length) return;

    var groups = {};

    Array.prototype.forEach.call(cards, function(card){
      var rc   = card.querySelector('.rating-count');
      var star = card.querySelector('.rating-star');
      var link = card.querySelector('a[href*="/products/"]');
      if (!rc || !star || !link) return;

      var title = cardTitle(card);
      var key   = title.split('|')[0].trim().toLowerCase();
      if (!key) return;

      /* originals only - see note 2 */
      var n = parseInt(rc.getAttribute('data-spb-orig') || '', 10);
      if (!isFinite(n)){
        n = readCount(rc);
        if (!isFinite(n)) return;
        rc.setAttribute('data-spb-orig', String(n));
      }

      var avg = parseFloat(star.getAttribute('data-spb-orig-avg') || '');
      if (!isFinite(avg)){
        var cs = window.getComputedStyle(star);
        var r  = parseFloat(cs.getPropertyValue('--rating'));
        var d  = parseFloat(cs.getPropertyValue('--rating-decimal'));
        avg = (isFinite(r) && isFinite(d)) ? (r - 1 + d) : NaN;
        if (isFinite(avg)) star.setAttribute('data-spb-orig-avg', avg.toFixed(4));
      }

      var g = groups[key] || (groups[key] = { products:{}, els:[] });
      g.products[productKey(link.getAttribute('href'))] = { n:n, avg:avg };  /* note 3 */
      g.els.push({ rc:rc, star:star });
    });

    Object.keys(groups).forEach(function(key){
      var g     = groups[key];
      var hrefs = Object.keys(g.products);
      if (hrefs.length < 2) return;          /* single colourway - leave alone */

      var total = 0, weighted = 0, weight = 0;
      hrefs.forEach(function(h){
        var p = g.products[h];
        total += p.n;
        if (isFinite(p.avg)){ weighted += p.avg * p.n; weight += p.n; }
      });
      if (!total) return;
      var avg = weight ? (weighted / weight) : NaN;

      g.els.forEach(function(x){
        if (x.rc.getAttribute('data-spb-merged') !== String(total)){
          x.rc.setAttribute('data-spb-merged', String(total));
          x.rc.textContent = ' (' + total + ') ';
          x.rc.setAttribute('aria-label', total + ' total reviews');
        }
        if (isFinite(avg)){
          var base = Math.floor(avg);
          x.star.style.setProperty('--rating', String(base + 1));
          x.star.style.setProperty('--rating-decimal', (avg - base).toFixed(2));
          x.star.setAttribute('aria-label', avg.toFixed(1) + ' out of 5.0 stars');
        }
      });
    });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
  setTimeout(run, 600);
  setTimeout(run, 1800);
})();